$(document).ready(function () {
    /**
     * @description - Initialize tab state based on URL parameter 'c'
     * This handles the case where Django templates are statically generated
     * and cannot use request.GET.c server-side
     * If no 'c' parameter, activate the first tab
     */
    function initTabFromUrlParam() {
        var urlParams = new URLSearchParams(window.location.search);
        var tabIdParam = urlParams.get("c");
        var $fundListTabs = $(".fund-list-tabs");

        if (!$fundListTabs.length) {
            return;
        }

        var $tabTitle = null;

        if (tabIdParam) {
            // Try to find the matching tab by URL parameter
            $tabTitle = $fundListTabs.find('.tabs-title[data-tab-id="' + tabIdParam + '"]');
        }

        // If no matching tab found or no URL param, use the first visible tab
        if (!$tabTitle || !$tabTitle.length) {
            $tabTitle = $fundListTabs.find(".tabs-title:not(.hide)").first();
        }

        if ($tabTitle && $tabTitle.length) {
            var tabId = $tabTitle.attr("data-tab-id");
            var tabText = $tabTitle.find("a").text().trim();

            // Activate the tab title
            $tabTitle.addClass("is-active").find("a").attr("aria-selected", "true");

            // Find and activate the corresponding panel
            var $tabsContent = $tabTitle.closest(".fil-tabs").find(".tabs-content");
            $tabsContent.find('.tabs-panel[data-tab-id="' + tabId + '"]').addClass("is-active");

            // Update page title and breadcrumb based on active tab (for mutual-funds pages)
            if ($fundListTabs.closest(".mutual-funds").length && tabText) {
                $("head title").text(tabText);

                // Update breadcrumb
                var $breadcrumbTitle = $(".section-breadcrumb .breadcrumb-title");
                if ($breadcrumbTitle.length) {
                    $breadcrumbTitle.text(tabText);
                }
            }
        }

        // Show tabs after determining the active state (prevents flash of wrong tab)
        $fundListTabs.addClass("tabs-ready");
    }

    // Initialize tabs from URL parameter before other tab setup
    initTabFromUrlParam();

    if (window.location.hash.length && window.location.hash.startsWith("#tab-")) {
        $(window.location.hash).trigger("click");
    }

    /**
     * @description - Tabs functionality
     */
    function measureTabs() {
        $(".fil-tabs")
            .each(function () {
                // get this instance of the tabs component
                let thisTabsInstance = $(this);

                // collect the tabPanels of this instance
                let tabPanels = thisTabsInstance.find(".tabs-panel");

                for (let i = tabPanels.length - 1; i >= 0; i--) {
                    let thisPanel = tabPanels.eq(i);
                    thisPanel.css({
                        display: "block",
                        height: "auto",
                        "transition-duration": "0",
                    });
                    let thisHeight = thisPanel.innerHeight();
                    thisPanel.attr("data-height", thisHeight);
                    thisPanel.removeAttr("style");
                }
            })
            .on("paginator:results-height-changed", function (event) {
                const $thisPanel = $(event.target).closest(".tabs-panel.is-active");
                if ($thisPanel.length) {
                    const thisHeight = $thisPanel.innerHeight();
                    $thisPanel.attr("data-height", thisHeight);
                    $thisPanel.parent().css("height", thisHeight);
                }
            });
        activateTab();
    }

    function activateTab() {
        $(".tabs-content").each(function (i, element) {
            const thisHeight = `${$(this).find(".tabs-panel.is-active").attr("data-height")}px`;
            // `changeable_height` is a switch to solve the possible problem that
            // might happen if the content in one of the tabs is too long
            if ($(element).hasClass("changeable_height")) {
                $(this).css("height", "auto");
            } else {
                $(this).css("height", thisHeight);
            }
        });
    }

    if ($(".fil-tabs").length > 0) {
        //now we load the main.css asynchronisly,
        //we need to wait for main.css finish loading, and then init the tabs.
        if (window.mainCSSLoader) {
            window.mainCSSLoader.addEventListener("load", function () {
                measureTabs();
            });
        }

        $(".fil-tabs .tabs-title.true-tab a").click(function (event) {
            event.preventDefault();
            var state = {
                id: $(this).attr("href").split("-")[1],
            };

            var currentPath = window.location.pathname;
            var searchParams = new URLSearchParams(window.location.search);

            // If it's a mutual-funds related tab and fil-tabs has fund-list-tabs class, update the 'c' parameter, page title and breadcrumb
            if ($(this).closest(".mutual-funds").length && $(this).closest(".fil-tabs").hasClass("fund-list-tabs")) {
                var tabId = $(this).attr("href").replace("#panel-", "").trim();
                var tabTitle = $(this).text().trim();

                // Only update the 'c' parameter, do not rebuild the entire URL
                var currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("c", tabId);
                window.history.replaceState({}, "", currentUrl.toString());

                // Update page title
                $("head title").text(tabTitle);

                // Update breadcrumb
                var $breadcrumbTitle = $(".section-breadcrumb .breadcrumb-title");
                if ($breadcrumbTitle.length) {
                    $breadcrumbTitle.text(tabTitle);
                }
            } else {
                console.log("Not a mutual-funds tab or not fund-list-tabs, skipping 'c' parameter update.");
                var queryParts = [];
                searchParams.forEach(function (value, key) {
                    queryParts.push(key + "=" + value);
                });
                var queryString = queryParts.join("&");
                var url = currentPath + (queryString ? "?" + queryString : "") + "#tab-" + state.id;

                if (!$(this).parent().hasClass("is-active")) {
                    history.replaceState(state, state.id, url);
                }
            }

            let thisIndex = $(this).parent().index();
            let thisContentPanel = $(this).closest(".fil-tabs").find(".tabs-content");
            let currentPanel = thisContentPanel.find(".tabs-panel.is-active");
            let currentHeight = currentPanel.attr("data-height");
            let newPanel = thisContentPanel.find(".tabs-panel").eq(thisIndex);
            let newHeight = newPanel.attr("data-height");
            let scaleOfChange = newHeight / currentHeight;

            if (newHeight !== currentHeight) {
                // have to use transform shorthand ( scale( 1 ) ) to reset scale for IE11 as it will not accept scale( 1,1 )
                (function () {
                    thisContentPanel
                        .css({
                            height: newHeight,
                            transform: `scale( 1,${scaleOfChange})`,
                            "transition-duration": "0s",
                        })
                        .promise()
                        .done(function () {
                            thisContentPanel.css({
                                transform: "scale( 1 )",
                                "transition-duration": "0.3s",
                                "transition-delay": "0.1s",
                            });
                        });
                })();
            }
        });
    }

    let resizeRaFTick = false;

    function windowResizingEvent() {
        requestRaFTick();
    }

    function requestRaFTick() {
        if (!resizeRaFTick) {
            requestAnimationFrame(update);
        }
        resizeRaFTick = true;
    }

    function update() {
        // reset the tick so we can
        // capture the next onScroll
        resizeRaFTick = false;

        // do what you want in debouced style
        measureTabs();
    }

    $(window).resize(windowResizingEvent);

    (function ($, sr) {
        // debouncing function from John Hann
        // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
        let debounce = function (func, threshold, execAsap) {
            let timeout;

            return function debounced() {
                let obj = this,
                    args = arguments;

                function delayed() {
                    if (!execAsap) {
                        func.apply(obj, args);
                    }
                    timeout = null;
                }

                if (timeout) {
                    clearTimeout(timeout);
                } else if (execAsap) {
                    func.apply(obj, args);
                }

                timeout = setTimeout(delayed, threshold || 100);
            };
        };
        // smartresize
        jQuery.fn[sr] = function (fn) {
            return fn ? this.bind("resize", debounce(fn)) : this.trigger(sr);
        };
    })(jQuery, "smartresize");
});
